import { EditorExtensionEnum as e } from "../enums/editor-extensions-enum.mjs";
//#region src/toolbar/toolbar-semantic-order.ts
var t = [
	e.History,
	[
		e.Heading,
		e.FontFamily,
		e.FontSize,
		e.TextColor,
		e.TextBackgroundColor
	],
	[
		e.Paragraph,
		e.LineHeight,
		e.Indent,
		e.TextAlign,
		e.Substitution
	],
	[
		e.Bold,
		e.Italic,
		e.Underline,
		e.Strike,
		e.BulletList,
		e.OrderedList
	],
	[
		e.Link,
		e.Image,
		e.SpecialCharacters
	]
];
//#endregion
export { t as semanticOrder };
